export var PARTICIPATED_ASSIGNMENT_RESPONDER_REPOSITORY = 'PARTICIPATED_ASSIGNMENT_RESPONDER_REPOSITORY';